import { render, staticRenderFns } from "./ArticleInfo.vue?vue&type=template&id=a192a502&scoped=true&"
import script from "./ArticleInfo.vue?vue&type=script&lang=ts&"
export * from "./ArticleInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleInfo.vue?vue&type=style&index=0&id=a192a502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a192a502",
  null
  
)

export default component.exports